import React from "react";
import {
  Create,
  SimpleForm,
  TextInput,
  ReferenceInput,
  SelectInput,
} from "react-admin";

const KioskCreate = ({ permissions, ...props }) => (
  <Create title="Créer une borne" {...props}>
    <SimpleForm>
      <TextInput source="title" label="Nom" />
      <TextInput source="serialno" label="Borne identifier" />
      <ReferenceInput label="Station" source="stationid" reference="stations">
        <SelectInput optionText="location" />
      </ReferenceInput>
    </SimpleForm>
  </Create>
);

export default KioskCreate;



// WEBPACK FOOTER //
// ./src/components/kioskCreate.js